import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'accordion-specs',
  templateUrl: './accordion-specs.component.html',
  styleUrls: ['./accordion-specs.component.sass']
})
export class AccordionSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/accordion/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
